export enum UpgradableStatus {
  NOT_UPGRADABLE = 0,
  UPGRADABLE = 1,
  JUST_UPGRADED = 2
}

export enum ConversionStrategy {
  ZERO = 0,
  ONE,
  TWO,
  THREE,
  FOUR,
  FIVE
}

export enum RecognitionStatus {
  OK = 'OK',
  IDENTIFICATION_IN_PROGRESS = 'IdentificationInProgress',
  NOT_IDENTIFIED = 'NotIdentified',
  LEGAL_VALIDATION_FAILED = 'LegalValidationFailed',
  DOCUMENTS_REQUIRED = 'DocumentsRequired',
  IDENTIFICATION_PENDING = 'IdentificationPending',
  TERRITORY_PENDING = 'TerritorioPending'
}

export enum SalesChannel {
  SPA = 'SPA',
  HOSTING = 'Hosting',
  PARTNER_PANEL = 'PannelloPartner'
}
